import { useState } from 'react';

const filters = [
  { label: 'All', value: 'all' },
  { label: 'Real Estate', value: 'real-estate' },
  { label: 'Renewable Energy', value: 'renewable-energy' },
  { label: 'Oil & Gas', value: 'oil-gas' },
  { label: 'Crypto & Digital', value: 'crypto' },
  { label: 'Medical Equipment', value: 'medtech' },
];

const projects = [
  {
    id: 1,
    title: 'Lake Geneva Commercial Tower',
    sector: 'real-estate',
    location: 'Geneva, Switzerland',
    value: '€340M',
    return: '14.2%',
    status: 'Active',
    description: 'Class-A commercial tower in Geneva\'s financial district. 42 floors of premium office space with panoramic views of Lake Geneva and the Alps.',
    image: 'https://readdy.ai/api/search-image?query=Premium%20modern%20glass%20skyscraper%20in%20Geneva%20Switzerland%20with%20Lake%20Geneva%20reflections%2C%20luxury%20commercial%20architecture%2C%20warm%20golden%20hour%20sunlight%2C%20professional%20editorial%20photography%2C%20bright%20and%20clean%20aesthetic&width=800&height=500&seq=port-grid-geneva-001&orientation=landscape',
  },
  {
    id: 2,
    title: 'Andalusia Solar Farm Complex',
    sector: 'renewable-energy',
    location: 'Seville, Spain',
    value: '€210M',
    return: '11.8%',
    status: 'Active',
    description: '450 MW utility-scale photovoltaic installation across 900 hectares in southern Spain. Powers 180,000 households with clean energy.',
    image: 'https://readdy.ai/api/search-image?query=Massive%20solar%20panel%20farm%20in%20Andalusia%20Spain%2C%20thousands%20of%20blue%20photovoltaic%20panels%20under%20bright%20sun%2C%20rolling%20hills%2C%20clean%20energy%20infrastructure%2C%20professional%20aerial%20style%2C%20warm%20tones&width=800&height=500&seq=port-grid-solar-002&orientation=landscape',
  },
  {
    id: 3,
    title: 'North Sea Gas Terminal',
    sector: 'oil-gas',
    location: 'Rotterdam, Netherlands',
    value: '€180M',
    return: '13.5%',
    status: 'Active',
    description: 'Midstream gas processing and storage terminal at Europe\'s largest port. Strategic infrastructure asset with 25-year offtake agreements.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20gas%20terminal%20at%20Rotterdam%20port%2C%20clean%20metallic%20pipelines%20and%20storage%20tanks%2C%20bright%20daylight%20sky%2C%20professional%20industrial%20photography%2C%20energy%20infrastructure%2C%20warm%20steel%20tones&width=800&height=500&seq=port-grid-gas-003&orientation=landscape',
  },
  {
    id: 4,
    title: 'LayerOne Blockchain Infrastructure',
    sector: 'crypto',
    location: 'Zug, Switzerland',
    value: '€45M',
    return: '22.0%',
    status: 'Active',
    description: 'Strategic investment in institutional-grade blockchain infrastructure. Validator nodes, staking services, and enterprise Web3 tooling.',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20data%20center%20with%20blockchain%20server%20racks%2C%20warm%20golden%20LED%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20premium%20technology%20photography%2C%20crypto%20mining%20infrastructure%2C%20professional%20atmosphere&width=800&height=500&seq=port-grid-crypto-004&orientation=landscape',
  },
  {
    id: 5,
    title: 'MedTech Precision Instruments',
    sector: 'medtech',
    location: 'Munich, Germany',
    value: '€120M',
    return: '15.6%',
    status: 'Active',
    description: 'Manufacturer of advanced surgical robotics and diagnostic imaging equipment. FDA and CE certified. Expanding into Asian markets.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20surgical%20robotic%20system%20in%20sterile%20operating%20room%2C%20advanced%20medical%20technology%2C%20clean%20white%20and%20steel%20aesthetic%2C%20professional%20healthcare%20photography%2C%20bright%20clinical%20lighting%2C%20premium%20medical%20equipment&width=800&height=500&seq=port-grid-medtech-005&orientation=landscape',
  },
  {
    id: 6,
    title: 'Berlin-Mitte Mixed-Use Development',
    sector: 'real-estate',
    location: 'Berlin, Germany',
    value: '€280M',
    return: '12.4%',
    status: 'Development',
    description: 'Mixed-use urban regeneration project in central Berlin. 45,000 sqm of residential, retail, and office space with sustainable design certification.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20mixed%20use%20urban%20development%20in%20Berlin%20Germany%2C%20contemporary%20architecture%20with%20glass%20and%20steel%2C%20green%20rooftops%2C%20bright%20daylight%2C%20professional%20architectural%20photography%2C%20warm%20and%20clean%20aesthetic&width=800&height=500&seq=port-grid-berlin-006&orientation=landscape',
  },
  {
    id: 7,
    title: 'Nordic Wind Park Expansion',
    sector: 'renewable-energy',
    location: 'Jutland, Denmark',
    value: '€165M',
    return: '10.9%',
    status: 'Active',
    description: 'Offshore and onshore wind turbine installations across the Danish peninsula. 320 MW combined capacity with grid-scale battery storage.',
    image: 'https://readdy.ai/api/search-image?query=Offshore%20wind%20turbines%20in%20the%20North%20Sea%20at%20sunrise%2C%20dramatic%20sky%20with%20warm%20colors%2C%20clean%20renewable%20energy%2C%20professional%20landscape%20photography%2C%20modern%20wind%20farm%2C%20bright%20and%20airy&width=800&height=500&seq=port-grid-wind-007&orientation=landscape',
  },
  {
    id: 8,
    title: 'DeFi Liquidity Protocol',
    sector: 'crypto',
    location: 'Dubai, UAE',
    value: '€35M',
    return: '18.5%',
    status: 'Active',
    description: 'Early-stage investment in a decentralized finance protocol providing institutional liquidity infrastructure across major blockchain networks.',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20finance%20visualization%20with%20golden%20geometric%20patterns%2C%20decentralized%20network%20concept%2C%20warm%20amber%20and%20cream%20tones%2C%20clean%20futuristic%20aesthetic%2C%20blockchain%20technology%2C%20professional%20design&width=800&height=500&seq=port-grid-defi-008&orientation=landscape',
  },
  {
    id: 9,
    title: 'Cardiac Imaging Systems',
    sector: 'medtech',
    location: 'Zurich, Switzerland',
    value: '€95M',
    return: '16.2%',
    status: 'Active',
    description: 'UK-based developer of AI-powered cardiac MRI and CT analysis systems. Deployed in 140+ hospitals across Europe and North America.',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20cardiac%20MRI%20imaging%20machine%20in%20modern%20hospital%20radiology%20department%2C%20clean%20sterile%20environment%2C%20professional%20medical%20technology%2C%20bright%20clinical%20lighting%2C%20premium%20healthcare%20photography&width=800&height=500&seq=port-grid-cardiac-009&orientation=landscape',
  },
  {
    id: 10,
    title: 'Paris Logistics Hub',
    sector: 'real-estate',
    location: 'Paris, France',
    value: '€195M',
    return: '11.2%',
    status: 'Active',
    description: 'Last-mile logistics portfolio across the Île-de-France region. 12 distribution centers serving e-commerce and retail supply chains.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20logistics%20warehouse%20distribution%20center%20near%20Paris%2C%20clean%20industrial%20architecture%2C%20trucks%20at%20loading%20docks%2C%20bright%20daylight%2C%20professional%20commercial%20real%20estate%20photography%2C%20warm%20tones&width=800&height=500&seq=port-grid-paris-010&orientation=landscape',
  },
  {
    id: 11,
    title: 'Caspian Pipeline Stake',
    sector: 'oil-gas',
    location: 'Baku, Azerbaijan',
    value: '€250M',
    return: '15.8%',
    status: 'Active',
    description: 'Strategic minority stake in a trans-Caspian pipeline consortium. Long-term revenue stream from European energy transit infrastructure.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20oil%20pipeline%20infrastructure%20stretching%20across%20landscape%20at%20sunset%2C%20dramatic%20sky%2C%20energy%20transportation%2C%20professional%20industrial%20photography%2C%20warm%20amber%20and%20golden%20tones&width=800&height=500&seq=port-grid-pipeline-011&orientation=landscape',
  },
  {
    id: 12,
    title: 'Biometric Health Sensors',
    sector: 'medtech',
    location: 'Boston, USA',
    value: '€75M',
    return: '19.3%',
    status: 'Development',
    description: 'Wearable continuous health monitoring platform using advanced biosensors. FDA breakthrough device designation for cardiac monitoring.',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20wearable%20health%20monitoring%20device%20on%20clean%20white%20surface%2C%20medical%20technology%20innovation%2C%20premium%20product%20photography%2C%20bright%20minimalist%20aesthetic%2C%20professional%20healthcare%20tech&width=800&height=500&seq=port-grid-biometric-012&orientation=landscape',
  },
];

export default function PortfolioPage() {
  const [activeFilter, setActiveFilter] = useState('all');

  const filtered = activeFilter === 'all'
    ? projects
    : projects.filter((p) => p.sector === activeFilter);

  return (
    <main>
      {/* Hero */}
      <section className="relative pt-0 pb-0 overflow-hidden">
        {/* Background Image */}
        <div className="relative h-[340px] md:h-[420px] w-full">
          <img
            src="https://readdy.ai/api/search-image?query=Premium%20modern%20glass%20skyscraper%20skyline%20at%20golden%20sunset%2C%20luxury%20real%20estate%20investment%20portfolio%2C%20reflective%20architectural%20facades%2C%20warm%20amber%20and%20gold%20professional%20photography%2C%20financial%20district%2C%20sophisticated%20wealth%20management%20aesthetic%2C%20bright%20dramatic%20sky&width=1920&height=600&seq=portfolio-hero-premium-2026&orientation=landscape"
            alt="Creighton Investments Ltd — Investment Portfolio"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55" />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 w-full">
              <div className="max-w-3xl">
                <span className="text-[10px] uppercase tracking-[3px] text-primary-300 font-semibold">
                  Our Investments
                </span>
                <h1 className="text-5xl md:text-7xl font-heading font-bold text-white mt-3 mb-5 tracking-tight">
                  Portfolio
                </h1>
                <p className="text-lg text-white/75 leading-relaxed max-w-2xl font-light">
                  A curated selection of our active investments across five diversified sectors. Each asset is evaluated through rigorous British due diligence, managed with institutional discipline, and monitored for long-term value creation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="sticky top-20 z-30 bg-white/95 backdrop-blur-md border-b border-foreground-100/20">
        <div className="max-w-[1440px] mx-auto px-4 md:px-12 py-3 md:py-4">
          <div className="flex items-center gap-1.5 md:gap-2 overflow-x-auto no-scrollbar -mx-1 px-1">
            {filters.map((f) => (
              <button
                key={f.value}
                onClick={() => setActiveFilter(f.value)}
                className={`shrink-0 text-[10px] md:text-xs uppercase tracking-[1.5px] font-semibold px-3 md:px-4 py-2 md:py-2.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeFilter === f.value
                    ? 'bg-primary-500 text-white shadow-sm'
                    : 'bg-background-50 text-foreground-500 hover:bg-background-100 hover:text-foreground-800'
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Project Grid */}
      <section className="py-10 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 md:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {filtered.map((project) => (
              <div
                key={project.id}
                className="group bg-background-50 rounded-2xl overflow-hidden border border-foreground-100/30 hover:border-primary-300/40 transition-all duration-500 cursor-pointer flex flex-col"
              >
                {/* Image */}
                <div className="relative h-44 md:h-52 overflow-hidden shrink-0">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-2.5 left-2.5">
                    <span className={`text-[8px] md:text-[9px] uppercase tracking-[2px] font-bold px-2 py-0.5 md:px-2.5 md:py-1 rounded-full ${
                      project.status === 'Development'
                        ? 'bg-amber-100 text-amber-700'
                        : 'bg-white/90 backdrop-blur-sm text-foreground-900'
                    }`}>
                      {project.status}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-4 md:p-6 flex flex-col flex-1">
                  {/* Sector Tag */}
                  <span className="text-[8px] md:text-[9px] uppercase tracking-[2px] text-primary-500 font-semibold">
                    {filters.find((f) => f.value === project.sector)?.label}
                  </span>
                  <h3 className="text-sm md:text-lg font-heading font-bold text-foreground-950 mt-1 mb-1.5 leading-snug">
                    {project.title}
                  </h3>
                  <div className="flex items-center gap-1.5 text-foreground-400 text-[11px] md:text-xs mb-2.5">
                    <i className="ri-map-pin-line text-xs" />
                    <span>{project.location}</span>
                  </div>
                  <p className="text-foreground-500 text-[12px] md:text-sm leading-relaxed mb-4 line-clamp-2">
                    {project.description}
                  </p>

                  {/* Stats Footer — pushed to bottom */}
                  <div className="mt-auto pt-3 md:pt-4 border-t border-foreground-100/40 flex items-center justify-between">
                    <div className="flex-1">
                      <p className="text-[8px] md:text-[9px] uppercase tracking-[2px] text-foreground-300 font-medium">Value</p>
                      <p className="text-sm md:text-base font-heading font-bold text-foreground-950">{project.value}</p>
                    </div>
                    <div className="w-px h-8 md:h-10 bg-foreground-100/30 mx-3" />
                    <div className="flex-1 text-right">
                      <p className="text-[8px] md:text-[9px] uppercase tracking-[2px] text-foreground-300 font-medium">Return</p>
                      <p className="text-sm md:text-base font-heading font-bold text-accent-600">{project.return}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-20">
              <div className="w-14 h-14 rounded-2xl bg-background-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-folder-open-line text-2xl text-foreground-300" />
              </div>
              <p className="text-foreground-400 text-base">No projects found in this sector yet.</p>
              <p className="text-foreground-300 text-sm mt-1">Try selecting a different filter above.</p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}